import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import ScorecardReportModel from 'scoreboard/reports/scorecard-report/scorecard-report-model'
import projects from 'scoreboard/projects/projects'

var MetricFrequencyModel = ScorecardReportModel.extend({
	defaults: function() {
		return _.extend(ScorecardReportModel.prototype.defaults(), {
			label: i18n.get('report.metricUpdateFrequencyReport.title'),
			filters: {
				scorecardNodeIds: [{
					values: []
				}],
				nativeCalendarIds: [{
					values: []
				}],
				types: [{
					values: ['metric']
				}],
				projectIds: [{values:[projects.id]}]
			},
			structure: {
				stacks: [
					this._defaultStackData('label', {sortType: 'tree'}),
					this._defaultStackData('id'),
					this._defaultStackData('calendar-id')
				]
			}
		})
	}
})

export default MetricFrequencyModel

MetricFrequencyModel.__filename__ = 'reports/wizard/metric-frequency/metric-frequency-model.js'
